<template>
  <div>
    <div class="izpis-opisa-zascita-varnost" v-for="opis in OpisiPaketa">
      <img src="/static/img/kljukica2.svg"/>
      {{ opis }}
    </div>
  </div>
</template>

<script>
export default {
  props: ['OpisiPaketa']
}
</script>
<style scoped src="../../../../../../static/css/Naroci/NarociInternet/infoKomponentaOpisPandaPaketa.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Naroci/NarociInternet/InfoKomponentaOpisPandaPaketa.vue